import { Charts } from './Charts';
import DetailsChartsDataProvider from './contexts/DetailsChartsDataContext';

const DetailsWrapper = () => {
    return (
        <DetailsChartsDataProvider>
            <Charts />
        </DetailsChartsDataProvider>
    );
};

export default DetailsWrapper;
